import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpenseReject = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .929688,
			y: .373047,
			width: 15.9963,
			height: 16,
			rx: 7.99817,
			fill: "#DC3636"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.4727 5.78711L6.38265 10.8771",
			stroke: "white",
			strokeWidth: .599862
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.4727 10.877L6.38265 5.78695",
			stroke: "white",
			strokeWidth: .599862
		})
	]
});
export default SvgExpenseReject;
